<app-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  icon="room-type"
  [header]="'+INSTALLATIONS.SRC.SINGLE_ROOM_CONTROL' | translate"
  [srcOverlayType]="singleRoomControlOverlays.SingleRoomControlDetails"
  [installationId]="installationId"
  [gatewaySerial]="gatewaySerial"
>
  <div header *ngIf="status$ | async | ready as status" class="flex flex-row gap-[4px]">
    <ng-container *ngIf="!(devicesStore.isSelectedDeviceOBNG$ | async)">
      <app-pill
        *ngIf="status?.properties?.active?.value"
        [type]="pillType.success"
        data-at-src-status-active
        >{{ '+INSTALLATIONS.SRC.ACTIVE.YES' | translate }}</app-pill
      >
      <app-pill
        *ngIf="!status?.properties?.active?.value"
        [type]="pillType.medium"
        data-at-src-status-active
        >{{ '+INSTALLATIONS.SRC.ACTIVE.NO' | translate }}</app-pill
      >
    </ng-container>
  </div>

  <!-- no src device banner -->
  <ng-container
    feature
    *ngIf="
      (status$ | async | ready)?.properties?.active?.value === false &&
      commissioningService.getDevicesCount(gatewayStore.devices$ | async) < 1
    "
  >
    <app-banner
      *ngIf="devicesStore.getIsStoreAvailableForSrc$ | async"
      [title]="'+SRC_PANEL.NO_SRC_DEVICE_BANNER_HEADER' | translate"
      [link]="viessmannShop"
      [linkLabel]="'+INSTALLATIONS.INSTALLATION.PARTNERSHOP.STORE_LINK' | translate"
      linkGtm="onGoToShop"
      linkGtmAction="Buy SRC"
      linkGtmCategory="src"
      type="info"
      feature
      isFullWidth="true"
    >
      {{ '+SRC_PANEL.NO_SRC_DEVICE_BANNER_BODY' | translate }}
    </app-banner>
  </ng-container>

  <!-- ppm above threshold -->
  <ng-container feature *ngIf="installationFeaturesStore.co2LevelStatus$ | async as status">
    <ng-container [ngSwitch]="status">
      <app-banner
        *ngSwitchCase="Co2LevelStatus.AboveThreshold"
        class="banner__threshold-banner"
        [type]="'info'"
      >
        {{ '+INSTALLATIONS.INSTALLATION.PPM_THRESHOLD_BANNER.DESCRIPTION' | translate }}
      </app-banner>

      <app-banner
        *ngSwitchCase="Co2LevelStatus.CriticalThreshold"
        class="banner__threshold-banner"
        [type]="'warning'"
      >
        {{ '+INSTALLATIONS.INSTALLATION.PPM_CRITICAL_THRESHOLD_BANNER.DESCRIPTION' | translate }}
      </app-banner>
    </ng-container>
  </ng-container>

  <!-- rooms -->
  <ng-container feature *ngIf="rooms$ | async | ready as feature">
    <ng-container *ngFor="let rId of feature | featureValue: featurePropertyKey.enabled">
      <ng-container *ngIf="rooms[rId] | async | ready as room">
        <ng-container *ngIf="room.properties?.actors?.value?.length > 0">
          <ng-container *ngIf="getRoomTemperature(rId) | async as settings">
            <ng-container *ngIf="getRoom(rId) | async as roomItem">
              <app-feature-tile
                feature
                preLabel="{{ '+INSTALLATIONS.INSTALLATION.SRC.CURRENT_TEMP' | translate }}"
                label="{{ roomItem | value2: featurePropertyKey.name }}"
                [value]="settings | temperatureUnit"
              >
                <vi-icon
                  class="childlock-icon"
                  *ngIf="
                    (getChildLockForRoom(rId)
                      | async
                      | ready
                      | value2: featurePropertyKey.status) === featurePropertyKey.active
                  "
                  name="lock-default"
                  [size]="20"
                  [matTooltip]="'+INSTALLATIONS.SRC.CHILDLOCK.TOOLTIP' | translate"
                  matTooltipPosition="above"
                ></vi-icon>
              </app-feature-tile>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- other rooms -->
  <ng-container feature *ngFor="let otherRoom of otherRooms$ | async; let i = index">
    <ng-container *ngIf="(otherRoom | ready) && otherRoom?.properties?.active?.value">
      <ng-container *ngIf="getOtherRoomActiveProgram(i + '') | async | ready as activeProgram">
        <app-feature-tile
          feature
          label="{{
            otherRoom
              | value2: featurePropertyKey.name || '+INSTALLATIONS.SRC.OTHER_ROOM.TITLE'
              | translate
          }}"
          value="{{ activeProgram | value2: featurePropertyKey.temperature }} {{
            activeProgram | unit: 'temperature'
          }}"
          [error]="activeProgram | error"
        ></app-feature-tile>
      </ng-container>
    </ng-container>
  </ng-container>
</app-features-container>
